import React from "react";
import { Link } from "react-router-dom";
import { useGetMyDietsQuery } from "../api/logbookDietApi";

export default function MyAssignedDietsPage() {
  const { data, isLoading, error, refetch } = useGetMyDietsQuery();

  // LOGIC FIX:
  // 1. Identify the nested data correctly
  const rawDiets = data?.diets ?? data?.data ?? data;

  // 2. Only assign to 'diets' if it is actually an array.
  // If the API returns { message: "..." }, diets becomes an empty array to prevent .map() crash.
  const diets = Array.isArray(rawDiets) ? rawDiets : [];

  // 3. Capture the message if the user isn't an assessor (and data isn't an array)
  const serverMessage =
    !Array.isArray(data) && data?.message ? data.message : null;

  return (
    <div className="bg-white border rounded-xl p-6">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h1 className="text-xl font-bold text-gray-800">My Assigned Diets</h1>
          <p className="text-sm text-gray-500 mt-1">
            Diets assigned to you for assessment.
          </p>
        </div>

        <button
          onClick={() => refetch()}
          className="px-4 py-2 rounded-lg border hover:bg-gray-50 text-sm transition-colors"
        >
          Refresh
        </button>
      </div>

      {isLoading ? (
        <div className="mt-6 text-gray-600 animate-pulse">Loading diets...</div>
      ) : error ? (
        <div className="mt-6 p-4 bg-red-50 border border-red-200 text-red-600 rounded-lg">
          Failed to load diets. Please check your connection.
        </div>
      ) : serverMessage ? (
        /* Handle the "You are not an assessor" state specifically */
        <div className="mt-6 p-4 bg-amber-50 border border-amber-200 text-amber-700 rounded-lg flex flex-col gap-2">
          <p className="font-bold uppercase text-xs tracking-wider">
            Access Restricted
          </p>
          <p className="text-sm">{serverMessage}</p>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          {diets.map((d: any) => (
            <div
              key={d.id}
              className="border rounded-xl p-4 hover:shadow-sm transition-shadow"
            >
              <div className="font-semibold text-gray-800">{d.title}</div>
              <div className="text-sm text-gray-500 mt-1">
                {d.start_date} → {d.end_date}
              </div>
              <div className="text-xs text-gray-500 mt-2 italic">
                Status:{" "}
                <span className="font-bold text-indigo-600 uppercase">
                  {d.status}
                </span>
              </div>

              <div className="mt-4 flex items-center gap-2">
                <Link
                  to={`/assessor/logbook-diets/${d.id}/logbooks`}
                  className="px-3 py-1.5 rounded-lg bg-gray-900 text-white hover:bg-gray-800 text-xs font-medium transition-colors"
                >
                  View my logbooks
                </Link>
              </div>
            </div>
          ))}

          {diets.length === 0 && !serverMessage && (
            <div className="text-gray-500 py-10 text-center border-2 border-dashed rounded-xl">
              No diets have been assigned to your account yet.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
